import styled from 'styled-components';
import { Column, Spacing, theme } from '@dls/web';

export const StyledModalDiv = styled.div({
  padding: '20px',
  backgroundColor: theme.main.colours.tertiary.l6
});

export const StyledColumn = styled(Column)`
  text-align: center;
`;

export const ImageContainer = styled(Spacing)`
  text-align: center;
  img {
    width: 100%;
  }
`;
